<template>
  <!-- Begin Page Content -->
  <div class="container">
    <div class="row justify-content-between">
      <div class="col">
        <h1 class="h3 mb-2 text-center text-gray-800">Миний хичээлүүд</h1>
      </div>
    </div>
    <div v-if="cusDoc && cusDoc.alerts && cusDoc.alerts.length > 0">
      <p
        v-for="alert in cusDoc.alerts"
        class="text-center text-primary py-2"
        style="border: 1px dashed #4e73df; border-radius: 10px"
      >
        {{ alert }}
      </p>
    </div>

    <!-- DataTales Example -->
    <div
      class="card shadow my-4"
      v-for="semester in semesters"
      v-bind:key="semester.id"
    >
      <div class="card-header row m-0">
        <div class="col">
          <h4 class="text-primary">{{ semester.title }}</h4>
        </div>
        <!-- <div v-if='semester.default==true' class="col-auto"><router-link v-bind:to="'/lessonadd/'+semester.id"> <div class="btn btn-success btn-sm">Хичээл нэмэх</div></router-link></div> -->
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
            v-if="semester.lessons != null && semester.lessons.length > 0"
          >
            <thead>
              <tr>
                <th>№</th>
                <th style="width: 40%">Нэр</th>
                <th>Xичээлийн код</th>
                <th>Мэдээлэл</th>
                <th>Төлөв</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(lesson, index) in semester.lessons"
                v-bind:key="lesson.id"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ lesson.name }}</td>
                <td>{{ lesson.lectureCode }}</td>
                <td>
                  <div v-if="lesson.numberOfStudents">
                    Оюутан: {{ lesson.numberOfStudents }}
                  </div>
                  <!-- <div v-else title="Та оюутан нэмээгүй байна.Оюутнууд энэ хичээлийг үзэж чадахгүй.">
                          <i class="text-danger fas fa-exclamation-triangle mr-2"></i>
                          <span class="text-danger">оюутан нэмээгүй</span> TODOX
                        </div> -->
                  <div v-if="lesson.numberOfTopics">
                    <small>Сэдэв: {{ lesson.numberOfTopics }}</small>
                  </div>
                  <div v-if="lesson.numberOfVideos">
                    <small>Видео хичээл: {{ lesson.numberOfVideos }}</small>
                  </div>
                  <!-- <div v-else title="Та видео хичээл оруулаагүй эсвэл видео хичээлээ буруу оруулсан байна.">
                          <i class="text-warning fas fa-exclamation-triangle mr-2"></i>
                          <span class="text-danger">видео оруулаагүй</span>
                        </div> TODOX-->
                </td>
                <td>
                  <h6 v-if="lesson.published == true" style="cursor: pointer">
                    <span class="badge badge-success"
                      ><small>Нээлттэй</small></span
                    >
                  </h6>
                  <h6 v-else style="cursor: pointer">
                    <span class="badge badge-danger"
                      ><small>Хаалттай</small></span
                    >
                  </h6>
                </td>
                <td>
                  <div class="row">
                    <button
                      class="btn btn-outline-primary btn-sm mx-1"
                      @click="goDetail(lesson)"
                    >
                      хараx
                    </button>
                    <button
                      class="btn btn-warning btn-sm mx-1"
                      @click="edit(lesson)"
                    >
                      засах
                    </button>
                    <!-- <div class="btn btn-danger btn-sm mx-1" @click="askCopyLesson(lesson)">Copy</div> -->
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="alert alert-info text-center">
            Та {{ semester.title }} семестерт ямар нэгэн хичээл оруулаагүй
            байна.
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="copyModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="copyModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="qaModalLabel">Хичээл хуулах</h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="copyLesson != null">
            <h3>
              Та {{ copyLesson.name }} хичээлийг хуулах уу? Хэрэв хуулах бол
              доорх хичээлийн улирлуудаас сонгоно уу
            </h3>
            <div class="row">
              <div class="col form-group">
                <label for="exampleFormControlSelect1">Улирал:</label>
                <select class="form-control" v-model="copySemester">
                  <option
                    v-for="semester in semesters"
                    v-bind:key="'semester-' + semester.id"
                    v-bind:value="semester.id"
                  >
                    {{ semester.title }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Болих
            </button>
            <button
              @click="doCopy"
              type="button"
              class="btn btn-primary btn-user btn-block"
            >
              Хуулах
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import { currentUser } from "../firebaseConfig.js";
import moment from "moment";
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Hellow",
      lessons: [],
      trending: {
        content: [],
      },
      semesters: [],
      copyLesson: null,
      copySemester: null,
      cusDoc: null,
    };
  },
  computed: {
    ...mapState(["currentUser", "userProfile"]),
  },
  created() {
    this._getLessons();
  },
  methods: {
    _getLessons() {
      var _this = this;
      var vm = this;
      // var query=fb.db.collection("lessons").where("userId", "==", this.$store.getters.currentUser.uid);

      // query.get().then(function(querySnapshot) {
      //           _this.lessons = [];
      //           querySnapshot.forEach(function(doc) {
      //               let object=doc.data()
      //               object.id = doc.id
      //     _this.lessons.push(object);

      // 	});
      // });
      if (this.userProfile && this.userProfile.customer) {
        this.userProfile.customer.get().then((cusDoc) => {
          let object = cusDoc.data();
          object.id = cusDoc.id;
          this.cusDoc = object;
          console.log(this.cusDoc);
        });
      }

      fb.db
        .collection("semester")
        .orderBy("index", "desc")
        .get()
        .then((semestersSnapshot) => {
          semestersSnapshot.forEach((semesterDoc) => {
            let object = semesterDoc.data();
            object.id = semesterDoc.id;
            object.lessons = [];
            if (
              this.cusDoc &&
              this.cusDoc.role &&
              this.cusDoc.role == "admin"
            ) {
              fb.db
                .collection("lessons")
                .where("semester", "==", semesterDoc.ref)
                .onSnapshot((querySnapshot1) => {
                  object.lessons = [];
                  querySnapshot1.forEach((lessonDoc) => {
                    let lesson = lessonDoc.data();
                    lesson.id = lessonDoc.id;
                    object.lessons.push(lesson);
                  });
                });
            } else {
              fb.db
                .collection("lessons")
                .where("teacher", "==", this.userProfile.customer)
                .where("semester", "==", semesterDoc.ref)
                .onSnapshot((querySnapshot1) => {
                  object.lessons = [];
                  querySnapshot1.forEach((lessonDoc) => {
                    let lesson = lessonDoc.data();
                    lesson.id = lessonDoc.id;
                    object.lessons.push(lesson);
                  });
                });
            }
            _this.semesters.push(object);
          });
        });
    },
    askCopyLesson(lesson) {
      var r = confirm(
        "Та " + lesson.name + " хичээлийг хуулахдаа итгэлтэй байна уу!!!"
      );
      if (r == true) {
        this.copyLesson = lesson;
        $("#copyModal").modal("show");
      }
    },
    async doCopy(lesson) {
      if (
        this.copyLesson != null &&
        this.copySemester != null &&
        this.copySemester != ""
      ) {
        var copyLessonRef = await fb.db.collection("lessons").doc();
        var tmpLesson = Object.assign({}, this.copyLesson);
        delete tmpLesson.id;
        tmpLesson.createdAt = new Date();
        tmpLesson.lectureCode = new Date().getTime();
        tmpLesson.copiedFrom = fb.db
          .collection("lessons")
          .doc(this.copyLesson.id);
        tmpLesson.semester = fb.db
          .collection("semester")
          .doc(this.copySemester);
        tmpLesson.copiedAt = new Date();
        tmpLesson.published = false;

        copyLessonRef.set(tmpLesson);

        var topicDocs = await fb.db
          .collection("lessons/" + this.copyLesson.id + "/topics")
          .orderBy("createdAt")
          .get();

        for (const topic of topicDocs.docs) {
          console.log(topic);
          var tmpTopic = topic.data();
          var copyTopicRef = copyLessonRef.collection("topics").doc();
          copyTopicRef.set(tmpTopic);

          var detailDocs = await fb.db
            .collection(
              "lessons/" +
                this.copyLesson.id +
                "/topics/" +
                topic.id +
                "/details"
            )
            .orderBy("createdAt")
            .get();

          for (const detail of detailDocs.docs) {
            var tmpdetail = detail.data();
            copyTopicRef.collection("details").doc().set(tmpdetail);
          }
        }

        this.copyLesson = null;
        this.copySemester = null;
        $("#copyModal").modal("hide");
      } else {
        alert("Та хуулах хичээл болон улиралаа заавал сонгоно уу");
      }
    },

    goDetail(lesson) {
      // if(lesson.isBlock!=true && (lesson.school==null || lesson.department==null || lesson.program==null)){
      //   alert("Та эхлээд хичээлийнхээ сургууль , тэнхим болон хөтөлбөрийг сонгоно уу");
      //   this.$router.push({ name: 'LessonEdit', params: { lessonId: lesson.id} });
      // }
      // else
      this.$router.push({
        name: "LessonDetail",
        params: { lessonId: lesson.id },
      });
    },
    edit(lesson) {
      this.$router.push({
        name: "LessonEdit",
        params: { lessonId: lesson.id },
      });
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
  },
};
</script>
